module.exports = {
          srcSet: __webpack_public_path__ + "769f6b4e62f1f40bd6561c15fdc6594f-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "769f6b4e62f1f40bd6561c15fdc6594f-2336.png",width: 2336,height: 496}],
          src: __webpack_public_path__ + "769f6b4e62f1f40bd6561c15fdc6594f-2336.png",
          toString:function(){return __webpack_public_path__ + "769f6b4e62f1f40bd6561c15fdc6594f-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACeL3P0rjuH/KYna/iqF0v8Cb8b+JV+v/qpMfv9cQFz+cHRw/0BfdfsAD3DD/RVuuv8SaLH+FWSp/wRaoP8zVY//wW6M/ph/k/7Go4D/TFRh+2V4Ln261DpdAAAAAElFTkSuQmCC",
          width: 2336,
          height: 496
        }